function jsonp(url:string, callback:string):void{
    let s = document.getElementById('item');
    // @ts-ignore
    if(s) document.body.removeChild(s);
    let script = document.createElement('script');//创建script标签
    script.type = 'text/javascript';
    script.src = url+callback;
    script.id = 'item';
    document.body.appendChild(script)//将能实现发送跨域请求的script标签插入html
}
export { jsonp }